import script from "./ChangeApproveStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeApproveStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangeApproveStatusModal.vue?vue&type=style&index=0&id=47f52b1f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f52b1f"]])

export default __exports__